import { closeLinkContextMenu } from '../../components/LinkContextMenu';
import datapoints from '../../datapoints';
import { getPermissionLevelIcon } from '../getPermissionLevelIcon';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import { getAttachmentPermissionLevelString } from 'owa-attachment-link-common';
import { ONE_DRIVE_PRO } from 'owa-attachment-link-common';
import { getEndpointUrlFromCanonicalUrl } from 'owa-attachment-link-common';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getSharingLink, SharingLinkInfo, updateSharingLinkFromSharingDialog } from 'owa-link-data';
import { refreshSharingTipsForLink } from 'owa-link-data';
import { lazyOpenSharingDialog, SharingDialogResponse } from 'owa-sharing-dialog';
import * as React from 'react';

const styles = require('../../components/LinkContextMenuCustomItems.scss');

let openSharingDialog;

export function getChangePermissionSharingDialogContextMenuItem(
    linkId: string
): IContextualMenuItem | null {
    if (!isFeatureEnabled('doc-attachment-sharingDialog')) {
        return null;
    }

    const sharingLink: SharingLinkInfo = getSharingLink(linkId);
    return {
        key: 'ChangePermissionsSharingDialog',
        onRender: (
            item: any,
            dismissMenu: (ev?: any, dismissAll?: boolean) => void
        ): React.ReactNode => {
            return (
                <button
                    className={styles.menuItemContainer}
                    aria-label={getAttachmentPermissionLevelString(
                        sharingLink.permissionLevel,
                        ONE_DRIVE_PRO
                    )}
                    aria-posinset={1}
                    aria-setsize={7}
                    aria-disabled="false"
                    role="menuitem"
                    onClick={() => {
                        logUsage(
                            datapoints.AttachmentLinkViewChangePermissionSharingDialog.datapoint
                                .name
                        );
                        onChangePermissionsClickedInternal(sharingLink);
                    }}
                    tabIndex={0}>
                    <div className={styles.permissionIconContainer}>
                        <img
                            src={getPermissionLevelIcon(sharingLink.permissionLevel)}
                            className={styles.permissionIcon}
                        />
                    </div>
                    <div className={styles.text}>
                        {getAttachmentPermissionLevelString(
                            sharingLink.permissionLevel,
                            ONE_DRIVE_PRO
                        )}
                    </div>
                </button>
            );
        },
    };
}

async function onChangePermissionsClickedInternal(sharingLink: SharingLinkInfo) {
    closeLinkContextMenu();
    if (!openSharingDialog) {
        openSharingDialog = await lazyOpenSharingDialog.import();
    }

    const canonicalUrl = sharingLink.sharingInfo.canonicalUrl;
    const endpointUrl = getEndpointUrlFromCanonicalUrl(canonicalUrl);
    openSharingDialog(endpointUrl, canonicalUrl, sharingLink.sharingInfo.shareId)
        .then((response: SharingDialogResponse) => {
            updateSharingLinkFromSharingDialog(sharingLink.linkId, response);
            refreshSharingTipsForLink(sharingLink.linkId);
        })
        .catch(() => {});
}
